<template>
  <div class="border-t border-dashed my-4" :class="props.isActive ? 'border-red-50' : 'text-gray-40'" />
</template>

<script setup lang="ts">
interface Props {
  isActive?: boolean
}

const props = withDefaults(defineProps<Props>(), { isActive: true })
</script>
